import React, {
  forwardRef,
  useImperativeHandle,
  useRef,
  useState
} from 'react'

import { FormHandles } from '@unform/core'
import {
  Botao,
  DataInputUnform,
  FormUnform,
  ModalBase,
  ModalRef,
  MoedaInputUnform,
  SelectOpcao,
  SelectUnform
} from 'src/componentes'
import { ArquivoInputUnform } from 'src/componentes/unform/input/arquivo'
import { FormaPagamentoCobranca, BaixaManualTaxaRescisao } from 'src/tipos'

import { schema } from './schema'
import {
  ContainerDoConteudo,
  ContainerDosBotoes,
  ContainerModal,
  TituloPrincipal
} from './styles'
import { ModalBaixaManualTaxaRescisaoProps } from './tipos'

export interface ModalBaixaManualTaxaRescisaoRef
  extends Omit<ModalRef, 'abrir'> {
  abrir: (valorPagamento: number) => void
}

const formasPagamento: SelectOpcao[] = [
  { id: FormaPagamentoCobranca.Boleto, texto: 'Boleto' },
  { id: FormaPagamentoCobranca.CartaoCredito, texto: 'Cartão de Crédito' },
  { id: FormaPagamentoCobranca.Cheque, texto: 'Cheque' },
  { id: FormaPagamentoCobranca.Deposito, texto: 'Depósito' },
  { id: FormaPagamentoCobranca.Dinheiro, texto: 'Dinheiro' },
  { id: FormaPagamentoCobranca.PagSeguro, texto: 'PagSeguro' },
  { id: FormaPagamentoCobranca.PayPal, texto: 'PayPal' },
  { id: FormaPagamentoCobranca.Pix, texto: 'Pix' },
  { id: FormaPagamentoCobranca.TED, texto: 'TED' }
]

const Modal: React.ForwardRefRenderFunction<
  ModalBaixaManualTaxaRescisaoRef,
  ModalBaixaManualTaxaRescisaoProps
> = ({ backdrop, acaoPrimaria }, ref) => {
  const [carregando, definirCarregando] = useState(false)
  const [aberta, definirAberta] = useState(false)
  const [valorPagamentoInicial, definirValorPagamentoInicial] = useState(null)
  const formRef = useRef<FormHandles>(null)

  const fechar = () => definirAberta(false)
  const abrir = (valorPagamento: number) => {
    definirValorPagamentoInicial(valorPagamento)
    definirAberta(true)
  }

  useImperativeHandle<
    ModalBaixaManualTaxaRescisaoRef,
    ModalBaixaManualTaxaRescisaoRef
  >(ref, () => ({
    fechar,
    abrir
  }))

  const acaoSucessoForm = async (dados: BaixaManualTaxaRescisao) => {
    try {
      definirCarregando(true)
      await acaoPrimaria(dados)
    } finally {
      fechar()
      formRef.current?.reset()
      definirCarregando(false)
    }
  }

  return (
    <ModalBase
      id="modal-baixa-manual-taxa-rescisao"
      aberta={aberta}
      backdrop={backdrop}
    >
      <ContainerModal>
        <TituloPrincipal>
          Realizar baixa manual da taxa de Rescisão
        </TituloPrincipal>
        <FormUnform
          ref={formRef}
          acaoSucesso={acaoSucessoForm}
          schema={schema}
          dadosIniciais={{ valorPagamento: valorPagamentoInicial }}
        >
          <ContainerDoConteudo>
            <SelectUnform
              id="slct-forma-pagamento-baixa-rescisao"
              label="Forma de Pagamento"
              name="formaPagamento"
              opcoes={formasPagamento}
            />

            <DataInputUnform
              label="Data de Pagamento"
              name="dataPagamento"
            />
            <MoedaInputUnform
              label="Valor de Pagamento"
              name="valorPagamento"
            />
            <ArquivoInputUnform
              label="Comprovante de Pagamento"
              name="comprovante"
              tiposAceitos={['.pdf', '.jpg', '.png']}
            />
          </ContainerDoConteudo>
          <ContainerDosBotoes>
            <Botao
              texto="Cancelar"
              tema="Secundario"
              type="button"
              onClick={() => fechar()}
            />
            <Botao texto="Salvar" carregando={carregando} />
          </ContainerDosBotoes>
        </FormUnform>
      </ContainerModal>
    </ModalBase>
  )
}

export const ModalBaixaManualTaxaRescisao = forwardRef(Modal)
